export const env = process.env.TARGET_ENV || process.env.NODE_ENV || 'production';
export const isDevelopment = env === 'development';
export const isStaging = env === 'staging';
export const isProduction = env === 'production';

// todo: remove after deployed to prod and checked
console.log(`Current env = ${env}`);
